// extracted by mini-css-extract-plugin
export default {"container":"Gallery_container__TCR+b","imageContainer":"Gallery_imageContainer__ShaF7","image":"Gallery_image__2oCv2"};